import * as React from 'react';
import GroupContext from '../GroupContext';
import {GroupObject} from '../types';

/**
 * Get the group context.
 * @return {GroupObject}
 */
export default function useGroupContext(): GroupObject {
  const context = React.useContext(GroupContext);

  if (context === undefined) {
    throw new Error('useGroupContext must be used within a filter group');
  }

  return context;
}
